import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { NavController, LoadingController, MenuController, PopoverController, AlertController } from '@ionic/angular';
import { Router } from '@angular/router';

import { Constants } from '../../models/constants';

import { Alert } from '../../services/alert';
import { UserService } from '../../services/user-service';
import { Util } from '../../services/util';
import { ProfPicService } from '../../services/prof-pic-service';
import { RoomTasks } from '../../services/room-tasks'
import { BusinessTasks } from '../../services/business-tasks'
import { PromoService } from 'src/app/services/promo-service';
import { VibeToast } from 'src/app/services/vibe-toast';

import { AnalyticsService } from 'src/app/services/analytics-service';
import { MetaTagService } from 'src/app/services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

import { Clipboard } from '@ionic-native/clipboard/ngx';

@Component({
  selector: 'app-business',
  templateUrl: './business.page.html',
  styleUrls: ['./business.page.scss'],
})
export class BusinessPage implements OnInit {

  paymentCardString: string = '';
  paymentAdded = false
  isMenuOpen = false

  commissionOptions: any[] = []

  businessImgURL?: string

  formatPercentage = Util.formatPercentage

  constructor(
    private navCtrl: NavController,
    private loadingCtrl: LoadingController,
    private alert: Alert,
    private alertCtrl: AlertController,
    private observables: ObservableService,
    private changeRef: ChangeDetectorRef,
    public userService: UserService,
    public toast: VibeToast,
    private menuCtrl: MenuController,
    private metaTagService: MetaTagService,
    private clipboard: Clipboard,
  ) {

    if (this.userService.user && !this.userService.user.type) {
      this.navCtrl.navigateForward(`/business-change-login`);
    }

    const business = this.userService.business;

    if (!business) {
      const sub = this.observables.businessFetched.subscribe(() => {
        sub.unsubscribe()
        let eventualLoad = true
        this.loadUIContent(eventualLoad)
      });
      return
    }

    this.loadUIContent()
  }

  ngOnInit() { }

  loadUIContent(eventualLoad?: boolean) {

    if (!this.userService.business) return;

    if (this.userService.business.pic) {
      this.businessImgURL = this.userService.business.pic;
    } else {
      this.businessImgURL = "assets/img/profile-placeholder.png";
    }

    this.commissionOptions = this.userService.getBusinessCommissionOptions()

    let paymentAdded = Util.isDefined(this.userService.user.customer) && Util.isDefined(this.userService.user.customer.last4);
    this.paymentCardString = 'No payment added';
    if (paymentAdded) {
      this.paymentCardString = `Card ending ${this.userService.user.customer.last4}`;
      if (this.userService.user.customer.cardBrand) {
        this.paymentCardString = `${this.userService.user.customer.cardBrand} ending *${this.userService.user.customer.last4}`;
      }
    }

    if (eventualLoad) {
      this.changeRef.detectChanges()
    }
  }

  ionViewWillEnter() {
    this.metaTagService.updateTitle('Business Settings')
    // this.metaTagService.updateTags({
    //   facebookURL: 'https://app.getshortcut.co/account',
    //   keywords: 'account settings, profile settings, account, profile',
    //   facebookTitle: 'Account | Shortcut',
    //   twitterTitle: 'Account | Shortcut',
    //   description: 'Access and update your Shortcut account settings.',
    //   facebookDescription: 'Access and update your Shortcut account settings.',
    //   twitterDescription: 'Access and update your Shortcut account settings.',
    // })

    this.loadUIContent()

    this.menuCtrl.enable(true);
  }

  ionViewDidEnter() {
    this.observables.publishSetCurrentMenuRoot('/business')
  }

  updatePayment() {
    this.navCtrl.navigateForward('/payment')
  }

  private error(msg: string) {
    this.alert.show("Error", msg);
  }

  logOut() {

    this.alert.show("Log out", "Are you sure you want to sign out?", "Log out", () => {
      this.observables.publishLogOut()
    }, "Cancel", () => { })
  }

  openPage(url: string) {
    window.open(url, '_blank')
  }

  async adminChat() {
    this.observables.publishOpenNewAdminChat();
  }

  async resetPassword() {

    let loading = await this.loadingCtrl.create()
    loading.present()

    this.userService.resetPassword(this.userService.user.email, () => {
      loading.dismiss();
      this.alert.show('Reset Password', 'Email sent to reset your password.')
    }, (errMsg: string) => {
      loading.dismiss();
      console.error(errMsg)
    })

  }

  viewLocations() {
    this.navCtrl.navigateForward('/locations')
  }

  emailFromBrowser() {
    let helpEmail = 'support@getshortcut.co'
    let subject = 'Contact Shortcut'
    let body = ''
    window.location.href = 'mailto:' + helpEmail + '?subject=' + subject + '&body=' + body
  }

  // NOTE: No longer available to business accounts. Only Admins.
  // openSccToThisPage() {
  //   window.open(`${Constants.SCC_ADMIN_URL}/#/businessSettings`, '_blank')
  // }

  businessLink() {
    if (!this.userService.business) return '';
    return `https://shortcut.app.link/${this.userService.business.link || ('?business=' + this.userService.business.id)}`
  }

  copyLink() {
    let link = this.businessLink()

    if (Constants.BROWSER_MODE) {
      navigator.clipboard.writeText(link).then(() => {
        this.alert.show("Link copied.", "This link will go to your landing page on web and mobile. Please note, you must log out of your Business Account to view your page as a customer.", "Ok")
      }, (err) => {
        this.alert.show('Error copying text', '')
      })
      return
    }

    this.clipboard.copy(link);
    this.alert.show("Link copied.", "This link will go to your landing page on web and mobile. Please note, you must log out of your Business Account to view your page as a customer.", "Ok")
  }


  async promptAddCommissionOption() {

    let alert = await this.alertCtrl.create({
      header: 'Add commission tier for your Pros',
      inputs: [
        {
          name: 'name',
          placeholder: 'Name for this tier'
        },
        {
          name: 'commissionPercent',
          placeholder: 'Enter % as number (ie. 60)',
          type: 'number',
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Add option',
          handler: (data: any) => {
            let name = data.name
            let commission = parseInt(data.commissionPercent) / 100
            this.addCommissionOption(name, commission)
          }
        }
      ]
    });
    alert.present();
  }

  private async addCommissionOption(name: string, commission: number) {

    if (!name) {
      this.error('Invalid name.')
      return
    }
    if (!commission && commission !== 0) {
      this.error('Invalid commission.')
      return
    }

    let loading = await this.loadingCtrl.create()
    loading.present()

    BusinessTasks.addBusinessCommissionOption(name, commission, () => {

      this.userService.fetch(() => {

        this.commissionOptions = this.userService.getBusinessCommissionOptions()
        this.changeRef.detectChanges()

        loading.dismiss();

      }, (err: string) => {
        loading.dismiss();
        this.error(err)
      })

    }, (err: string) => {
      loading.dismiss();
      this.error(err)
    })
  }

}
